import { Component, OnInit, inject } from '@angular/core';
import { TotpLoginRequest } from '../../../backend/model';
import { TotpService } from '../../../backend/api/totp.service';
import { AuthenticationContextDatasourceService } from '../../../backend/datasource';
import { TotpAuthenticationFormComponent } from '../../component/totp-authentication-form/totp-authentication-form.component';
import { IDCardModule } from '@inera/ids-angular/components/card';
import { ThemeHandlerService } from '../../service/theme-handler.service';
import { NgTemplateOutlet } from '@angular/common';
import { ThemeType } from '../../../backend/model/theme-type';

@Component({
  selector: 'totp-authentication',
  imports: [TotpAuthenticationFormComponent, IDCardModule, NgTemplateOutlet],
  templateUrl: './totp-authentication.component.html',
  styleUrl: './totp-authentication.component.css'
})
export class TotpAuthenticationComponent implements OnInit {
  private totpService = inject(TotpService);
  private authenticationContextDatasource = inject(AuthenticationContextDatasourceService);
  private themeService = inject(ThemeHandlerService);

  public clientInfo;

  public themeType = ThemeType;

  public mainTheme: string = '';

  ngOnInit(): void {
    this.clientInfo = this.authenticationContextDatasource.getClientInfo();

    this.themeService.getTheme().subscribe(theme => {
      this.mainTheme = theme.value.value.theme.mainTheme;
    });
  }

  public getTypeText(): string {
    return this.authenticationContextDatasource.getIsSignature() ? 'Jag signerar hos' : 'Jag legitimerar mig hos';
  }

  public login(request: TotpLoginRequest): void {
    this.totpService.login(request, this.authenticationContextDatasource.getSessionId()).subscribe(it => {
      if (it.success) {
        window.location.href = it.redirectUrl;
      }
    });
  }
}
